export default __webpack_public_path__ + "static/media/InstagramAccount.57f62a68.svg";